## OpenID Connect

The OIDC plugin allows you to integrate Hawtio console with generic OIDC provider.
